module.exports = __webpack_public_path__ + "img/SPTC.989340d1.jpg";